import { render, staticRenderFns } from "./AssetLocks.vue?vue&type=template&id=b9ef4c6e&scoped=true&"
import script from "./AssetLocks.vue?vue&type=script&lang=js&"
export * from "./AssetLocks.vue?vue&type=script&lang=js&"
import style0 from "./AssetLocks.vue?vue&type=style&index=0&id=b9ef4c6e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ef4c6e",
  null
  
)

export default component.exports